import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { AuthConstants } from "../config/auth-constants";
import { StorageService } from "../services/storage.service";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class InitialRedirectGuard implements CanActivate {
  constructor(
    public storageService: StorageService,
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (state.url.startsWith("/auth")) {
      return Promise.resolve(true);
    }
    return new Promise(async (resolve) => {
      try {
        const authData = await this.storageService.get(AuthConstants.AUTH);

        if (authData && authData.admin) {
          // Usuario autenticado - redirigir a cursos
          console.log("Usuario autenticado, redirigiendo a cursos");
          this.authService.userPerfil$.next(authData.admin);
          resolve(this.router.createUrlTree(["/cursos"]));
        } else {
          // Usuario no autenticado - redirigir a login
          console.log("Usuario no autenticado, redirigiendo a login");
          resolve(this.router.createUrlTree(["/auth/login"]));
        }
      } catch (err) {
        console.error("Error en InitialRedirectGuard:", err);
        // En caso de error, redirigir a login
        resolve(this.router.createUrlTree(["/auth/login"]));
      }
    });
  }
}
